(ns dashboard.views.analysis.analysis-bank.config
  (:require [reitit.frontend.easy :as rfe]))

(def view-id :view/analysis-bank)

(defn breadcrumbs []
  [{:href (rfe/href :route.view/home)
    :label "Dashboard"}
   {:href (rfe/href view-id)
    :label "Analyses"
    :active? true}])
